import { SocketConnectionStatus } from '@/hooks/useClassroomSession/useClassroomSession';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DisconnectedDialogProps {
    open: boolean;
    connectionStatus: SocketConnectionStatus;
}

export function DisconnectedDialog({ open, connectionStatus }: DisconnectedDialogProps) {
    const { t } = useTranslation();

    const title = connectionStatus === 'disconnected' ? t('classroom.connection.disconnected.manualReconnectTitle') : t('classroom.connection.disconnected.title');
    const description = connectionStatus === 'disconnected' ? t('classroom.connection.disconnected.manualReconnectDescription') : t('classroom.connection.disconnected.description');

    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <Dialog open={open} disableEscapeKeyDown>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <Typography>{description}</Typography>
            </DialogContent>
            {connectionStatus === 'disconnected' && (
                <DialogActions>
                    <Button onClick={handleRefresh} variant='contained' color='primary'>
                        {t('common.refresh')}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}
